/** Session flag: waitstaff PIN login should stay on simplified Mobile POS. */

export const WAITSTAFF_MOBILE_SESSION_KEY = 'kingspark_waitstaff_mobile';

export function readWaitstaffMobileSession(): boolean {
  try {
    return sessionStorage.getItem(WAITSTAFF_MOBILE_SESSION_KEY) === '1';
  } catch {
    return false;
  }
}

export function writeWaitstaffMobileSession(enabled: boolean) {
  try {
    if (enabled) sessionStorage.setItem(WAITSTAFF_MOBILE_SESSION_KEY, '1');
    else sessionStorage.removeItem(WAITSTAFF_MOBILE_SESSION_KEY);
  } catch {
    // ignore
  }
}

export function clearWaitstaffMobileSession() {
  writeWaitstaffMobileSession(false);
}
